import React from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import { useAuth } from '../contexts/AuthContext'; // Adjust path if needed
import { Button } from './ui/button'; // Adjust path if needed
import LogoutButton from './LogoutButton'; // Adjust path if needed

const Header = () => {
  const { session } = useAuth();
  const location = useLocation(); // Get current location

  return (
    <header className="sticky top-0 z-50 w-full py-4 px-6 md:px-10 flex justify-between items-center border-b border-white/10 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="flex items-center gap-4"> {/* Wrap left items */}
        <Link to="/" className="flex items-center gap-2">
          <img src="/images/logo.svg" alt="Logo" className="h-8 w-auto" />
          <span className="text-xl font-bold">Headshot AI</span>
        </Link>
      </div>
      <div className="flex items-center gap-4"> {/* Right items */}
        {session ? (
          <>
            {location.pathname !== '/app' && (
              <Link to="/app">
                <Button
                  className="py-2 px-3 text-white font-semibold rounded-lg bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Go to App
                </Button>
              </Link>
            )}
            <LogoutButton />
          </>
        ) : (
          <Link to="/login">
            {/* Apply gradient styles similar to LandingPage Get Started, but default size */}
            <Button
              className="text-white font-semibold rounded-lg bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Login / Sign Up
            </Button>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
